export default {
  processing: 'Processando a consulta',
};
